import * as React from 'react';
import { PinterestShareButton, FacebookShareButton, TwitterShareButton, FacebookIcon, TwitterIcon } from 'react-share';
import { truncateText } from 'helpers/common';
import { ArticleMobileLikeButton } from 'components';

require('./style.css');

interface IProps {
	articleUrl: string;
	title: string;
	isAuthenticated: any;
	signinRedirect: any;
	isLiked: boolean;
	nowReadingText: string;
	shareText: string;
	backToTop: () => void;
	openSocialTab: any;
	likeItem: any;
	unlikeItem: any;
	articleScrollingHeight: any;
}

class ArticleMobileNavigation extends React.Component<IProps, {}> {
	public articleSubMenu: HTMLElement = undefined;
	public articleHeader: HTMLElement = undefined;

	constructor(props) {
		super(props);

		this.handleScroll = this.handleScroll.bind(this);
	}

	public componentDidMount() {
		this.articleSubMenu = document.getElementById('articleSubMenu');
		this.articleHeader = document.getElementById('articleHeaderHolder');

		if (this.articleHeader != null && this.articleHeader != null) {
			window.addEventListener('scroll', this.handleScroll);
		}
	}

	public componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	public handleScroll() {
		const scrollPos = window.scrollY;
		if (scrollPos > this.props.articleScrollingHeight) {
			if (!this.articleSubMenu.classList.contains('visible')) {
				this.articleSubMenu.classList.add('visible');
			}
		} else if (this.articleSubMenu.classList.contains('visible')) {
			this.articleSubMenu.classList.remove('visible');
		}
	}

	public render() {
		const {
			nowReadingText,
			title,
			isAuthenticated,
			signinRedirect,
			isLiked,
			likeItem,
			unlikeItem,
			shareText,
			openSocialTab,
			articleUrl,
			backToTop,
		} = this.props;

		const PinterestGalleryIcon = (
			<div style={{ width: 30, height: 30 }}>
				<svg viewBox="0 0 30 30" width="30" height="30" className="social-icon social-icon--pinterest">
					<g>
						<circle cx="30" cy="30" r="29" fill="#cb2128" />
					</g>
					<g>
						<path d="M17.1,19.3c-0.9,0-1.8-0.5-2.1-1.1c0,0-0.5,2-0.6,2.4c-0.4,1.4-1.5,2.7-1.6,2.8c-0.1,0.1-0.2,0.1-0.2,0c0-0.2-0.3-1.9,0-3.3c0.2-0.7,1.1-4.7,1.1-4.7s-0.3-0.5-0.3-1.4c0-1.3,0.8-2.2,1.7-2.2c0.8,0,1.2,0.6,1.2,1.3c0,0.8-0.5,2-0.8,3.1c-0.2,0.9,0.5,1.7,1.4,1.7c1.6,0,2.7-2.1,2.7-4.6c0-1.9-1.3-3.3-3.6-3.3c-2.6,0-4.3,2-4.3,4.2c0,0.8,0.2,1.3,0.6,1.7c0.2,0.2,0.2,0.3,0.1,0.5c0,0.2-0.2,0.5-0.2,0.7c-0.1,0.2-0.2,0.3-0.4,0.2c-1.2-0.5-1.8-1.8-1.8-3.3c0-2.5,2.1-5.4,6.2-5.4c3.3,0,5.5,2.4,5.5,5C21.8,16.8,19.9,19.3,17.1,19.3z" />
					</g>
				</svg>
			</div>
		);

		return (
			<div className="articleCardNavigation" id="articleSubMenu">
				<div className="articleNavContainer">
					<div className="articleNavNowReading" id="articleNavNowReading">
						<div className="label">{nowReadingText}</div>
						<div className="text">{truncateText(title, 40)}</div>
						<div className="clear" />
					</div>
					<ArticleMobileLikeButton
						isAuthenticated={isAuthenticated}
						signinRedirect={signinRedirect}
						isLiked={isLiked}
						likeItem={likeItem}
						unlikeItem={unlikeItem}
						shareText={shareText}
					/>
					<div className="articleNavSocialTab">
						<a href="#" className="share" onClick={openSocialTab}>
							<div className="text">{shareText}</div>
							<img className="icon" src={require('containers/Html/icons/share_white.svg')} />
							<div className="clear" />
						</a>
						<div className="shareTab">
							<PinterestShareButton url={articleUrl} media={'.'}>
								{PinterestGalleryIcon}
							</PinterestShareButton>
							<TwitterShareButton url={articleUrl} title={title}>
								<TwitterIcon size={30} round={true} />
							</TwitterShareButton>
							<FacebookShareButton url={articleUrl}>
								<FacebookIcon size={30} round={true} />
							</FacebookShareButton>
						</div>
					</div>
					<div className="backToTop" onClick={backToTop}>
						<img src={require('containers/Html/icons/to_top.svg')} />
					</div>
					<div className="clear" />
				</div>
				<div className="clear" />
			</div>
		);
	}
}

export { ArticleMobileNavigation };
